import React from "react";
import TickIcon from "@assets/images/black-tick.svg";

type LightCheckboxProps = {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

export const LightCheckbox = ({
  label,
  checked = false,
  onChange,
}: LightCheckboxProps) => {
  const handleClick = () => {
    onChange?.(!checked);
  };

  return (
    <div
      onClick={handleClick}
      className="flex items-center gap-2 cursor-pointer"
    >
      <div className="w-8 h-8 flex items-center justify-center border rounded-md transition-all border-grey-lightest">
        {checked && <TickIcon />}
      </div>
      {!!label && <span className="text-sm">{label}</span>}
    </div>
  );
};
